<ion-header>
  <ion-toolbar style="text-align: center;" color="secondary">
    <ion-title>{{('Choose RLS Input' | translate)}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="secondary">
  <form [formGroup]="RLSform" style="padding: 1.5em;">
    @if (emailConfigured || domainConfigured) {
      <div style="margin-top: 10px; margin-bottom: 10px;">
        <ion-item color="secondary" id="EmailRLSInput">
          <ion-label position="floating">
            {{ 'Email to use as RLS Input' | translate }}
          </ion-label>
          <ion-input type="text" formControlName="RLSPopoverInput"></ion-input>
        </ion-item>
        @if (RLSform.get('RLSPopoverInput')?.errors && RLSFormSubmitted) {
          <ion-item lines="none">
            <ng-container>
              <ion-text color="warning" style="font-size: 15px; margin-left: 17px; margin-bottom: 5px;">{{ 'Mandatory field' | translate }}</ion-text>
            </ng-container>
          </ion-item>
        }
        <div style="width:100%; display:flex; justify-content: end;">
          <ion-button color="tertiary" style="width:fit-content; align-self: flex-end; margin-right: 10px; margin-top: 10px;" (click)="openEmailPicker()">
            <label>{{ 'Choose an existing email' | translate }}</label>
          </ion-button>
        </div>
      </div>
    }
    @if (groupsConfigured) {
      <div>
        <ion-item>
          <ion-select label="{{ 'RLS Input' | translate }}" label-placement="stacked" formControlName="RLSPopoverInput" interface="popover" placeholder="{{('Select RLS Input' | translate)}}">
            @for (group of groups; track group) {
              <ion-select-option [value]="group.Name">{{group.Name}}</ion-select-option>
            }
          </ion-select>
        </ion-item>
        @if (RLSform.get('RLSPopoverInput')?.errors && RLSFormSubmitted) {
          <ion-item lines="none">
            <ng-container>
              <ion-text color="warning" style="font-size: 15px; margin-top: 5px; margin-bottom: 5px;">{{ 'Mandatory field' | translate }}</ion-text>
            </ng-container>
          </ion-item>
        }
      </div>
    }
    <br>
      @if (ssasEIdUsernameConfigured) {
        <div>
          <ion-item>
            <ion-input type="text" formControlName="RLSPopoverInput" label="{{ 'Enter SSAS EffectiveIdentity Username' | translate }}" labelPlacement="stacked"></ion-input>
          </ion-item>
          @if (RLSform.get('RLSPopoverInput')?.errors && RLSFormSubmitted) {
            <ion-text color="warning" style="font-size: 15px; margin-left: 17px; margin-top: 5px; margin-bottom: 5px;">{{ 'Mandatory field' | translate }}</ion-text>
          }
        </div>
      }
      <ion-button color="medium" expand="block" style="width: 60%; margin-left: 20%; margin-top: 10px;" (click)="dismissPopover()">
        {{ 'Submit' | translate }}
      </ion-button>
    </form>
  </ion-content>
